import {
  supportContactSchema,
  supportQueryPageSchema,
  supportQuerySchema,
  tutorialListSchema,
  type CreateSupportQueryInput,
  type SupportContact,
  type SupportQuery,
  type SupportQueryPage,
  type SupportStatus,
  type TutorialList,
} from '@tailoring-crm/shared';
import type { ApiClient } from '../api/client.js';

/** `/support` — the tutorials, our contact details, and the threads this shop has raised. */

const SUPPORT = '/support';

export async function getTutorials(client: ApiClient): Promise<TutorialList> {
  return await client.get(`${SUPPORT}/tutorials`, { schema: tutorialListSchema });
}

export async function getSupportContact(client: ApiClient): Promise<SupportContact> {
  return await client.get(`${SUPPORT}/contact`, { schema: supportContactSchema });
}

export interface SupportQueryListParams {
  status?: SupportStatus;
  openOnly?: boolean;
  page?: number;
  pageSize?: number;
}

export async function getSupportQueries(
  client: ApiClient,
  params: SupportQueryListParams = {},
): Promise<SupportQueryPage> {
  return await client.get(`${SUPPORT}/queries`, {
    schema: supportQueryPageSchema,
    query: {
      ...(params.status ? { status: params.status } : {}),
      ...(params.openOnly ? { openOnly: 'true' } : {}),
      ...(params.page ? { page: params.page } : {}),
      ...(params.pageSize ? { pageSize: params.pageSize } : {}),
    },
  });
}

export async function askSupportQuery(
  client: ApiClient,
  body: CreateSupportQueryInput,
): Promise<SupportQuery> {
  return await client.post(`${SUPPORT}/queries`, body, { schema: supportQuerySchema });
}

export async function replyToSupportQuery(
  client: ApiClient,
  queryId: string,
  message: string,
): Promise<SupportQuery> {
  return await client.post(
    `${SUPPORT}/queries/${queryId}/replies`,
    { message },
    { schema: supportQuerySchema },
  );
}

export async function closeSupportQuery(client: ApiClient, queryId: string): Promise<SupportQuery> {
  return await client.post(
    `${SUPPORT}/queries/${queryId}/close`,
    {},
    {
      schema: supportQuerySchema,
    },
  );
}
